// GET WINDOW SCROLL
import {isTabletAndBelow} from "./MediaQuery";

export function getScrollPosition() {
    return {
        top: Math.ceil(window.pageYOffset || document.documentElement.scrollTop),
        left: Math.ceil(window.pageXOffset || document.documentElement.scrollLeft)
    };
}

export function setScroll(map){
    if(isTabletAndBelow()){
        const mapSVG = map.querySelector('svg');
        const mapWidth = parseFloat(getComputedStyle(map, null).width.replace("px", ""));
        const mapSVGWidth = parseFloat(getComputedStyle(mapSVG, null).width.replace("px", ""));
        map.scrollLeft = (mapSVGWidth - mapWidth) / 3.5;
    }
}
